import type { NavigateFunction } from 'react-router-dom';
import { authService } from '../../features/auth/services/authService';
import { totemModeService } from './totemModeService';

/** Flag: TV precisa gerar QR de novo após sessão expirada (não é logout manual). */
export const TOTEM_NEEDS_RECONNECT_KEY = 'totem_needs_reconnect';

export const TOTEM_SESSION_EXPIRED_EVENT = 'totem-session-expired';

let reconnectInProgress = false;

export function markTotemNeedsReconnect(): void {
  sessionStorage.setItem(TOTEM_NEEDS_RECONNECT_KEY, '1');
}

export function clearTotemNeedsReconnect(): void {
  sessionStorage.removeItem(TOTEM_NEEDS_RECONNECT_KEY);
  reconnectInProgress = false;
}

export function totemNeedsReconnect(): boolean {
  return sessionStorage.getItem(TOTEM_NEEDS_RECONNECT_KEY) === '1';
}

/**
 * Avisa a UI de totem que a sessão de TV morreu.
 * Ignora se não estiver em modo totem (gestor/login normal não entra no fluxo de QR).
 */
export function notifyTotemSessionExpired(reason?: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (!totemModeService.isTotemMode()) {
    return;
  }
  if (reconnectInProgress || totemNeedsReconnect()) {
    return;
  }

  console.warn('[Totem] Sessão expirada / irrecuperável:', reason || 'desconhecido');
  window.dispatchEvent(
    new CustomEvent(TOTEM_SESSION_EXPIRED_EVENT, { detail: { reason } })
  );
}

/**
 * Sessão de TV irrecuperável: limpa o JWT, mantém modo totem e vai para o QR.
 * Diferente do "Sair" do totem (que desliga totem_mode).
 */
export function beginTotemSessionReconnect(navigate: NavigateFunction): void {
  if (reconnectInProgress) {
    return;
  }
  reconnectInProgress = true;
  markTotemNeedsReconnect();
  totemModeService.enableTotemMode();
  authService.logout();
  navigate('/televisao', { replace: true });
}
